import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa6';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { MdOutlineEdit } from 'react-icons/md';
import { DESCRIBE } from 'sequelize/lib/query-types';
import axios from 'axios'
import ResponseMsg2 from '../../general/ResponseMsg2';


const AddDormitory = ({setLoading}) => {

     const [response2, setResponse2] = useState({ message: '', status: 'success' });

    const [form, setform] = useState({
        dormitory_name: '',
        type: '',
        address: '',
        description: '',
    })

    const [searchFilter, setSearchFilter] = useState('');
    const [dormitory, setDormitory] = useState([]);
     const [showDelete, setShowDelete]  = useState(false);
     const [selectedDoor,setSelectDoor]= useState('');


    const handleChange = (e) => {
        const { name, value } = e.target;
        setform({
            ...form,
            [name]: value
        })
    }



    const handleSubmit = async (e) => {
    e.preventDefault();
  setLoading(true);

    try {
      const res = await axios.post(
        "https://api.kcian.in/add-dormitory",
        form,
        { headers: { "Content-Type": "application/json" } }
      );

      setResponse2({ message:  'Dormitory Added Successfully.', status: 'success' });
fetchHostel();
      
    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);
    } finally {
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
          setLoading(false);
    }
  };



    useEffect(() => {
        fetchHostel();
    }, []);


            const fetchHostel = async () => {
                  setLoading(true);

            try {
                const res = await axios.get('https://api.kcian.in/fetch-dormitory');
                setDormitory(res.data);
            } catch (error) {
                console.log(error)
            } finally {
                  setLoading(false);
            }
        }


    const handleDelete = async (id) => {
          setLoading(true);

        try {
            const res = await axios.delete(`https://api.kcian.in/delete-dormitory/${id}`);
            
         setResponse2({ message:  'Dormitory Removed Successfully.', status: 'success' });
         setShowDelete(false);
fetchHostel();
        } catch (err) {
            console.error(err.response?.data || err.message);
        } finally {
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
              setLoading(false);
        }
    };


   const handleShowDelete = (item) => {
    setSelectDoor(item);
    setShowDelete(true);
  }


    const filteredHostel = dormitory.filter(cls => {
  const term = searchFilter.toLowerCase();
  return (
    cls.dormitory_name.toLowerCase().includes(term) ||
    cls.type.toLowerCase().includes(term)
  );
});


    return (
        <>
            <section className='py-4'>
                <div className='px-4'>
                    <HeadingArea message1='Hostel' message2='Add Hostel' />

                       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                    <div className='row'>
                        <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>

                            <div className="profile-card">
                                <p className="profile-heading">Add Hostel</p>
                                <form className='mt-4' onSubmit={handleSubmit}>
                                        {/* Dormitory Name */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Dormitory Name*</label>
                                            <input
                                                type="text"
                                                name="dormitory_name"
                                                className="profile-input"
                                                value={form.dormitory_name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Type */}
                                        <div className='profile-input-area mb-4'>
                                            <label className='profile-badge'>Type*</label>
                                            <select name='type' className='profile-input'
                                                value={form.type}
                                                onChange={handleChange}
                                                required
                                            >
                                                <option value=''>Select Type...</option>
                                                <option value='Girl'>Girl</option>
                                                <option value='Boy'>Boy</option>
                                                <option value='other'>Other</option>
                                            </select>
                                        </div>
                                        {/* Address */}
                                        <div className="profile-input-area mb-4">
                                            <label className="profile-badge">Address*</label>
                                            <input
                                                type="text"
                                                name="address"
                                                className="profile-input"
                                                value={form.address}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        {/* Description */}
                                        <div className="profile-input-area mb-4">
                                            <label htmlFor="description" className="profile-badge">
                                                Description
                                            </label>
                                            <textarea id='description' name="description" className="profile-input" placeholder='Enter here...'
                                                value={form.description}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        {/* Button */}
                                        <div className="text-center">
                                            <button className="profile-btn" type='submit' ><FaCheck /> SAVE</button>
                                        </div>
                                </form>
                            </div>
                        </div>
                        <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                            <div className='profile-card'>

                                <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                    <span className="profile-heading align-content-center">Hostel List</span>

                                    <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                        <input
                                            type='text'
                                            name='search'
                                            className='profile-input border-bottom rounded-0'
                                            placeholder='Search...'
                                            value={searchFilter}
                                            onChange={(e) => setSearchFilter(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className='table-responsive'>
                                    <table className='w-100 text-center'>
                                        <thead className='account-thead'>
                                            <tr>
                                                <th className='rounded-start-4'>S No</th>
                                                <th>Dormitory Name </th>
                                                <th>Type</th>
                                                <th>Address</th>
                                                <th>Description</th>
                                                <th className='rounded-end-4'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredHostel.length > 0 ? (
                                                filteredHostel.map((data, id) => (
                                                    <tr className='account-tr' key={id}>
                                                        <td>{id + 1}</td>
                                                        <td>{data.dormitory_name}</td>
                                                        <td>{data.type}</td>
                                                        <td>{data.address}</td>
                                                        <td>{data.description || '--'}</td>
                                                        <td>
                                                         

                                                            <RiDeleteBin6Line className='account-icon1' title='Remove' onClick={() => handleShowDelete(data)} />
                                                        </td>
                                                    </tr>
                                                ))) :
                                                <tr>
                                                    <td colSpan="6" className='account-tr'>
                                                        No Hostel found.
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>

              
    {showDelete && (
        <>
          <section className='ins-dialog'>
            <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

              <p className='ins-dialog-heading text-danger'>Remove This Hostel</p>

              <div className='table-responsive'>
                <table className='w-100'>

                  <thead className='account-thead'>
                                                                    <th className='rounded-start-4'>Dormitory Name </th>
                                                <th>Type</th>
                                                <th>Address</th>
                                                <th className='rounded-end-4'>Description</th>
                  </thead>

                  <tr className='account-tr'>
                    <td>{selectedDoor.dormitory_name}</td>
                    <td>{selectedDoor.type}</td>
                    <td>{selectedDoor.address}</td>
                    <td>{selectedDoor.description || '--'}</td>

                  </tr>


                </table>
              </div>

              <p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Hostel & its data will be permanently removed.</p>

              <button className='profile-btn me-2' onClick={() => handleDelete(selectedDoor.id)}>Remove</button>
              <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


            </div>
          </section>
        </>
      )}

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AddDormitory